import React, { useState } from "react";
import SectionShell from "./SectionShell";

export default function FAQAccordion({ heading, items }) {
  const list = Array.isArray(items) ? items : [];
  const [openIndex, setOpenIndex] = useState(0);

  if (!list.length) return null;

  return (
    <div style={{ justifyContent:"center",display:'flex' }}>
    <SectionShell className="cl-faq">
      {heading ? <h2 className="cl-h2">{heading}</h2> : null}

      <div className="cl-faqList">
        {list.map((f, i) => {
          const isOpen = i === openIndex;

          return (
            <div
              key={`${f.q}-${i}`}
              className={`cl-faqItem ${isOpen ? "isOpen" : ""}`}
            >
              <div
                className="cl-faqQ"
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : i)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setOpenIndex(isOpen ? -1 : i);
                  }
                }}
              >
                <span className="cl-faqQText">{f.q}</span>
                <span className="cl-faqChevron" aria-hidden="true" />
              </div>

              {isOpen && <div className="cl-faqA">{f.a}</div>}
            </div>
          );
        })}
      </div>
    </SectionShell></div>
  );
}
